// extracted by mini-css-extract-plugin
export default {"block":"ui_block__EPlS+","title":"ui_title__f-6+0"};